import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";

// Action Types
export const LATEST_PRIMARY_EVENTS_SUCCESS = "LATEST_PRIMARY_EVENTS_SUCCESS";
export const LATEST_PRIMARY_EVENTS_ERROR = "LATEST_PRIMARY_EVENTS_ERROR";

// Thunk Action Creator
export const getLatestPrimaryEventsAction = createAsyncThunk(
    "api/Calendar/getLatestPrimaryEvents",
    async (json, { dispatch }) => {

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const response = await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/getLatestEvents`,
                {
                    AccessToken: json.accessToken,
                    CalendarId: json.calendarId,
                    Type: json.type,
                    TimeZone: timeZone
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )

            if (response.status === 200) {
                if (response.data === '') {
                    throw new Error("Problem getting latest calendar events. Logging the user out");
                } else {
                    if (response.data?.items && response.data.items.length > 0) {
                        dispatch({
                            type: LATEST_PRIMARY_EVENTS_SUCCESS,
                            payload: response.data,
                        });
                    }
                }
            }
        }
        catch (error) {
            dispatch({ type: LATEST_PRIMARY_EVENTS_ERROR, payload: error });
        }
    }
);
